var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListenAudioOff(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1097 12.4978C12.1861 12.4978 13.8694 10.8146 13.8694 8.73816C13.8694 6.66177 12.1861 4.97852 10.1097 4.97852C8.03335 4.97852 6.3501 6.66177 6.3501 8.73816C6.3501 10.8146 8.03335 12.4978 10.1097 12.4978Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.116 14.9039C14.5369 14.0955 12.4879 13.4376 10.1099 13.4376C7.73195 13.4376 5.68295 14.0955 4.1039 14.9039C3.64527 15.1401 3.26108 15.4988 2.99395 15.9401C2.72683 16.3814 2.58723 16.8882 2.59064 17.404V20.017H17.6292V17.404C17.6292 16.3513 17.0559 15.3832 16.116 14.9039V14.9039ZM19.8474 1.21875L18.5221 2.54403C19.7546 3.77877 20.4467 5.45205 20.4467 7.19659C20.4467 8.94113 19.7546 10.6144 18.5221 11.8492L19.8474 13.1744C20.6341 12.3903 21.2582 11.4587 21.6841 10.4328C22.1099 9.40705 22.3291 8.30728 22.3291 7.19659C22.3291 6.0859 22.1099 4.98613 21.6841 3.96033C21.2582 2.93453 20.6341 2.00286 19.8474 1.21875V1.21875Z",
    fill: "#9D9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1976 10.5241C18.0779 9.64242 18.5724 8.44742 18.5724 7.20149C18.5724 5.95557 18.0779 4.76057 17.1976 3.87891L15.8723 5.20418C16.4004 5.73288 16.697 6.44956 16.697 7.1968C16.697 7.94403 16.4004 8.66071 15.8723 9.18941L17.1976 10.5241Z",
    fill: "#9D9D9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenAudioOff);
export default __webpack_public_path__ + "static/media/listenAudioOff.407cbc6a4fe2ff4cc93d6f33e2f2482e.svg";
export { ForwardRef as ReactComponent };